import './MovesCounter.css';
import React from 'react';
import PropTypes from 'prop-types';

function MovesCounter({ movesUsed, maxMoves, levelID }) {
    const levelClass = `level-${levelID}`;
    const movesLeft = maxMoves - movesUsed;
    
    if (maxMoves === null) {
        return null;
    }

    return (
        <div className={`movesContainer ${levelClass}`}>
            moves left: {movesLeft}
        </div>
    );
}

MovesCounter.propTypes = {
    movesUsed: PropTypes.number.isRequired,
    maxMoves: PropTypes.number,
    levelID: PropTypes.string.isRequired
};

export default MovesCounter;